/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileAllegatoDTO } from './FileAllegatoDTO';
import {
    FileAllegatoDTOFromJSON,
    FileAllegatoDTOFromJSONTyped,
    FileAllegatoDTOToJSON,
    FileAllegatoDTOToJSONTyped,
} from './FileAllegatoDTO';

/**
 * 
 * @export
 * @interface LavoriDettaglioSpeseResponseDTO
 */
export interface LavoriDettaglioSpeseResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    idTipoRimborso?: number;
    /**
     * 
     * @type {string}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    valore?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    nonAddebitabile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    sostenuteSocieta?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    note?: string | null;
    /**
     * 
     * @type {Array<FileAllegatoDTO>}
     * @memberof LavoriDettaglioSpeseResponseDTO
     */
    readonly allegati?: Array<FileAllegatoDTO> | null;
}

/**
 * Check if a given object implements the LavoriDettaglioSpeseResponseDTO interface.
 */
export function instanceOfLavoriDettaglioSpeseResponseDTO(value: object): value is LavoriDettaglioSpeseResponseDTO {
    return true;
}

export function LavoriDettaglioSpeseResponseDTOFromJSON(json: any): LavoriDettaglioSpeseResponseDTO {
    return LavoriDettaglioSpeseResponseDTOFromJSONTyped(json, false);
}

export function LavoriDettaglioSpeseResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LavoriDettaglioSpeseResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idTipoRimborso': json['idTipoRimborso'] == null ? undefined : json['idTipoRimborso'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'valore': json['valore'] == null ? undefined : json['valore'],
        'nonAddebitabile': json['nonAddebitabile'] == null ? undefined : json['nonAddebitabile'],
        'sostenuteSocieta': json['sostenuteSocieta'] == null ? undefined : json['sostenuteSocieta'],
        'note': json['note'] == null ? undefined : json['note'],
        'allegati': json['allegati'] == null ? undefined : ((json['allegati'] as Array<any>).map(FileAllegatoDTOFromJSON)),
    };
}

export function LavoriDettaglioSpeseResponseDTOToJSON(json: any): LavoriDettaglioSpeseResponseDTO {
    return LavoriDettaglioSpeseResponseDTOToJSONTyped(json, false);
}

export function LavoriDettaglioSpeseResponseDTOToJSONTyped(value?: Omit<LavoriDettaglioSpeseResponseDTO, 'allegati'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idTipoRimborso': value['idTipoRimborso'],
        'descrizione': value['descrizione'],
        'valore': value['valore'],
        'nonAddebitabile': value['nonAddebitabile'],
        'sostenuteSocieta': value['sostenuteSocieta'],
        'note': value['note'],
    };
}

